<main class="main-content-container">
    <div class="lifebridge-eligibility-container">
        <div class="lifebridge-eligibility__header">
            <h2 class="lifebridge-eligibility__header-text">
                LifeBridge Eligibility
            </h2>
        </div>
    
        <div class="lifebridge-eligibility__paragraph">
            <p class="lifebridge-eligibility__text ">
                You are eligible to apply for the LifeBridge program if you are:
            </p>
            <div class="lifebridge-eligibility__list ">
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">Between the ages of 19 and 42;</p>
                </div>
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">The parent or legal guardian of one or more dependent children under age 18;</p>
                </div>
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">A permanent, legal resident of the United States;</p>
                </div>
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">Currently employed full or part time with a total family income not less than $10,000 or more than $40,000 annually;</p>
                </div>
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">The only parent or legal guardian in your household who has applied; and</p>
                </div>
                <div class="lifebridge-eligibility__list-item">
                    <div class="lifebridge-eligibility__eligibility-icon"></div>
                    <p class="lifebridge-eligibility__eligibility-description">In good health as determined by MassMutual’s underwriting guidelines.</p>
                </div>
            </div>
            <div class="lifebridge-eligibility__disclaimer">
                Note: The LifeBridge program is not designed to replace insurance coverage you already may have purchased.
            </div>
        </div>
        <div class="lifebridge-eligibility__acknowledgement">
            <div class="checkbox">
            <input type="checkbox"
                    id="eligibility-acknowledge"
                    class="checkbox__input"
                    (change)="toggleAcknowledged()" >
            <div class="label-basic">
                <label class="checkbox__label checkbox__label--light" for="eligibility-acknowledge">
                    I acknowledge the above is true.
                </label>
            </div>
        </div>
        </div>
    
        <div class="lifebridge-eligibility__button-container">
            <button class="button button--yellow button--primary"
                    [ngClass]="{'button--disabled': !acknowledged}"
                    [disabled]="acknowledged ? null : 'true'"
                    (click)="applyNow()">
                Apply Now
            </button>
        </div>
    </div>
</main>